module.exports = __webpack_public_path__ + "6187f6c5dfa7f756dca5f6f069953529.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/section2/imgs/2.jpg
// module id = 395
// module chunks = 0